export default __webpack_public_path__ + "static/media/EconomicsSupplyDemand_04.df22bc73.png";